import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Benefit, BenefitClaimStatus, BenefitQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BenefitInfoModalComponent } from '../benefit-info-modal/benefit-info-modal.component';

enum BUTTON_STATUS {
  AddBenefit,
  OutOfStock,
  ComingSoon,
  Expiried,
}
@Component({
  selector: 'fgb-benefit-item',
  templateUrl: './benefit-item.component.html',
  styleUrls: ['./benefit-item.component.scss'],
})
export class BenefitItemComponent implements OnInit, OnChanges {
  @Input() benefit: Benefit;
  @Input() disabled = false;
  @Input() numberClaimed: number;
  @Input() claimLimit: number | null;

  isClaimed: boolean;
  inactive: boolean = false;
  BUTTON_STATUS = BUTTON_STATUS;

  constructor(
    private modalService: NgbModal,
    private benefitQuery: BenefitQuery
  ) {}

  ngOnInit() {
    if (!this.benefitQuery.isActiveBenefit(this.benefit) && this.benefit.ShowWhenNotActive) {
      this.inactive = true;
    }
  }

  ngOnChanges() {
    this.isClaimed = this.isBenefitClaimed(this.benefit);
  }

  openInfoModal(benefit: Benefit): void {
    const modal = this.modalService.open(BenefitInfoModalComponent, {
      windowClass: 'benefit-item-info-modal',
      centered: true,
    });
    modal.componentInstance.benefit = benefit;
    modal.componentInstance.classifyStatusOfBenefit = this.classifyStatusOfBenefit;
    modal.componentInstance.claimLimit = this.claimLimit;
    modal.componentInstance.numberClaimed = this.numberClaimed;
  }

  get classifyStatusOfBenefit() {
    if (new Date(this.benefit.EndDate).getTime() < Date.now()) {
      return BUTTON_STATUS.Expiried;
    }
    if (new Date(this.benefit.StartDate).getTime() > Date.now()) {
      return BUTTON_STATUS.ComingSoon;
    }
    if (this.benefit.Status == BenefitClaimStatus.OutOfStock) {
      return BUTTON_STATUS.OutOfStock;
    } else return BUTTON_STATUS.AddBenefit;
  }

  isBenefitClaimed(benefit: Benefit): boolean {
    const claimedStatuses = [BenefitClaimStatus.Processed, BenefitClaimStatus.Unprocessed];
    return claimedStatuses.some((b) => b === benefit.Status);
  }
}
